import gql from "graphql-tag";

export const UNSUBSCRIBE_MUTATION = gql`
  mutation Unsubscribe($email: String!) {
    unsubscribe(email: $email)
  }
`;
